import { render, staticRenderFns } from "./relative-datetime.vue?vue&type=template&id=1b7ce06c"
import script from "./relative-datetime.vue?vue&type=script&lang=js"
export * from "./relative-datetime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports